import { BracketGroup, BracketTeam } from "@portal-frontend-ssr/blast-api";

export const getQualifyingTeams = (group: BracketGroup) => {
  const winners = group.matches.map((match) => {
    if (!match.isCompleted) return;
    if (match.teamAScore > match.teamBScore) {
      return match.teamA;
    } else if (match.teamAScore < match.teamBScore) {
      return match.teamB;
    }
  });
  return winners.filter((team) => team) as BracketTeam[];
};
